import React from "react";

const CustomPagination = () => {
  return <div></div>;
};

export default CustomPagination;
